import { render, staticRenderFns } from "./ClusterGridTab.vue?vue&type=template&id=2f32ff74&scoped=true"
import script from "./ClusterGridTab.vue?vue&type=script&lang=js"
export * from "./ClusterGridTab.vue?vue&type=script&lang=js"
import style0 from "./ClusterGridTab.vue?vue&type=style&index=0&id=2f32ff74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32ff74",
  null
  
)

export default component.exports